<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">

          <div class="hx-filters">
            <div class="filter">
              <small>{{ 'reports.filter.organization' | transloco }}</small>
              <app-organization-select
                [multiple]="true"
                [(ngModel)]="params.organizationIds"
                (selectChange)="onOrganizationChange()">
              </app-organization-select>
            </div>

            <div class="filter">
              <small>{{ 'reports.filter.shop' | transloco }}</small>
              <hx-store-select *ngIf="params.organizationIds?.length && showStoreSelect; else storeDisabledTpl"
                [(ngModel)]="params.storeIds"
                [multiple]="true"
                [default]="false"
                [filterFn]="onStoreFilterFn"
                (selectChange)="navigate()">
              </hx-store-select>

              <ng-template #storeDisabledTpl>
                <input class="form-control" type="text" disabled
                       [placeholder]="'reports.filter.shop' | transloco">
              </ng-template>
            </div>

            <div class="filter">
              <small>{{ 'reports.filter.date' | transloco }}</small>
              <hx-date-range-select
                [(ngModel)]="params.date"
                (selectChange)="navigate()">
              </hx-date-range-select>
            </div>
          </div>

          <div class="m--margin-top-15">
            <button
              type="button"
              (click)="resetFilter()"
              class="btn btn-outline-primary">
              {{ 'reset.list' | transloco }}
            </button>
          </div>

          <div *ngIf="snapshotRows.length" class="snapshots-panel m--margin-top-30">
            <div class="snapshots-toggle" (click)="snapshotsExpanded = !snapshotsExpanded">
              <h5 class="snapshots-title">
                <i class="la snapshots-state-icon" [ngClass]="snapshotsExpanded ? 'la-folder-open' : 'la-folder'"></i>
                {{ (snapshotRows.length > 1 ? 'cash-flows.balance-snapshots-plural' : 'cash-flows.balance-snapshots') | transloco }}
              </h5>
              <i class="la" [ngClass]="snapshotsExpanded ? 'la-angle-up' : 'la-angle-down'"></i>
            </div>
            <div *ngIf="snapshotsExpanded" class="snapshots-body">
            <div *ngFor="let row of snapshotRows" class="hx-filters m--margin-top-10">
              <div class="filter">
                <small>{{ 'reports.filter.organization' | transloco }}</small>
                <input class="form-control" type="text" disabled [value]="row.title | uiLabel">
              </div>
              <div class="filter">
                <small>{{ 'cash-flows.balance-start-date' | transloco }} <span class="required-mark">*</span></small>
                <hx-date-select [(ngModel)]="row.date" [disabled]="row.saved"></hx-date-select>
              </div>
              <div class="filter">
                <small>{{ 'cash-flows.balance' | transloco }} <span class="required-mark">*</span></small>
                <input class="form-control" type="number" required
                       [(ngModel)]="row.value" [disabled]="row.saved"
                       [class.is-invalid]="!row.saved && (row.value === null || row.value === undefined)">
              </div>
              <div class="filter" style="align-self: flex-end;">
                <button *ngIf="!row.saved" type="button" class="btn btn-primary"
                        [disabled]="row.saving || row.value === null || !row.date"
                        (click)="saveSnapshot(row)">
                  {{ 'btn.save' | transloco }}
                </button>
              </div>
            </div>
            </div>
          </div>

          <div *ngIf="cashflow && !isLoading.cashflow" class="block-table-scroll m--margin-top-30">
            <table class="m--margin-top-10 m--margin-bottom-40 table-report" style="width:100%; border-collapse: collapse;">
              <tbody>
              <tr class="row-balance">
                <td class="bold-main indent-1">{{ 'cash-flows.cashBalanceAtStartOfPeriod' | transloco }}</td>
                <td class="text-right bold-main">{{ (cashflow.openingBalance ?? 0) | number }}</td>
              </tr>
              <tr class="row-section">
                <td class="bold-main indent-1">{{ 'cash-flows.operatingActivities' | transloco }}</td>
                <td class="text-right"></td>
              </tr>
              <tr>
                <td class="indent-1">(+) {{ 'cash-flows.cashInflows' | transloco }}</td>
                <td class="text-right">{{ (cashflow.sumProduct + cashflow.sumService + cashflow.sumProperty + cashflow.sumDelivery) | number }}</td>
              </tr>
              <tr>
                <td class="detail-row">{{ 'cash-flows.salesFinishedGoods' | transloco }}</td>
                <td class="text-right">{{ cashflow.sumProduct | number }}</td>
              </tr>
              <tr>
                <td class="detail-row">{{ 'cash-flows.advanceReceivedForFinishedGoodsSupply' | transloco }}</td>
                <td class="text-right">{{ 0 | number }}</td>
              </tr>
              <tr>
                <td class="detail-row">{{ 'cash-flows.paymentForProcessingServices' | transloco }}</td>
                <td class="text-right">{{ cashflow.sumService | number }}</td>
              </tr>
              <tr>
                <td class="detail-row">{{ 'cash-flows.paymentForDeliveryOfFinishedGoods' | transloco }}</td>
                <td class="text-right">{{ cashflow.sumProperty | number }}</td>
              </tr>
              <tr>
                <td class="detail-row">{{ 'cash-flows.salesAdditionalProducts' | transloco }}</td>
                <td class="text-right">{{ cashflow.sumDelivery | number }}</td>
              </tr>
              <tr>
                <td class="indent-1">(-) {{ 'cash-flows.cashOutflow' | transloco }}</td>
                <td class="text-right">{{ (cashflow.sumRawMaterials + cashflow.sumProductions + cashflow.sumAdmins + cashflow.sumCommercials + cashflow.sumRoyaltyExpenses + cashflow.sumOthers + cashflow.sumTaxesProfit) | number }}</td>
              </tr>
              <tr>
                <td class="detail-row">{{ 'cash-flows.rawMaterialPurchase' | transloco }}</td>
                <td class="text-right">{{ cashflow.sumRawMaterials | number }}</td>
              </tr>
              <tr>
                <td class="detail-row">{{ 'cash-flows.productionExpenses' | transloco }}</td>
                <td class="text-right">{{ cashflow.sumProductions | number }}</td>
              </tr>
              <tr>
                <td class="detail-row">{{ 'cash-flows.administrativeExpenses' | transloco }}</td>
                <td class="text-right">{{ cashflow.sumAdmins | number }}</td>
              </tr>
              <tr>
                <td class="detail-row">{{ 'cash-flows.commercialExpenses' | transloco }}</td>
                <td class="text-right">{{ cashflow.sumCommercials | number }}</td>
              </tr>
              <tr>
                <td class="detail-row">{{ 'cash-flows.royalty' | transloco }}</td>
                <td class="text-right">{{ cashflow.sumRoyaltyExpenses | number }}</td>
              </tr>
              <tr>
                <td class="detail-row">{{ 'cash-flows.otherExpenses' | transloco }}</td>
                <td class="text-right">{{ cashflow.sumOthers | number }}</td>
              </tr>
              <tr>
                <td class="detail-row">{{ 'cash-flows.taxes' | transloco }}</td>
                <td class="text-right">{{ cashflow.sumTaxesProfit | number }}</td>
              </tr>
              <tr class="row-section">
                <td class="bold-main indent-1">(=) {{ 'cash-flows.netCashFlowFromOperatingActivities' | transloco }}</td>
                <td class="text-right bold-main">{{ (cashflow.sumProduct + cashflow.sumService + cashflow.sumProperty + cashflow.sumDelivery) - (cashflow.sumRawMaterials + cashflow.sumProductions + cashflow.sumAdmins + cashflow.sumCommercials + cashflow.sumRoyaltyExpenses + cashflow.sumOthers + cashflow.sumTaxesProfit) | number }}</td>
              </tr>
              <tr class="row-balance">
                <td class="bold-main indent-1">{{ 'cash-flows.cashBalanceAtEndOfPeriod' | transloco }}</td>
                <td class="text-right bold-main">{{ (cashflow.openingBalance ?? 0) + (cashflow.sumProduct + cashflow.sumService + cashflow.sumProperty + cashflow.sumDelivery) - (cashflow.sumRawMaterials + cashflow.sumProductions + cashflow.sumAdmins + cashflow.sumCommercials + cashflow.sumRoyaltyExpenses + cashflow.sumOthers + cashflow.sumTaxesProfit) | number }}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <hx-loader [length]="cashflow ? 1 : 0" [isLoading]="isLoading.cashflow"></hx-loader>

        </div>
      </div>
    </div>
  </div>
</div>
